module.exports = __webpack_public_path__ + "static/media/gmca-removebg-preview.15c28cd1.png";